import type { FamilyProfile } from '../types';
import { formatLastSeen } from '../lib/time';

interface AvatarStackProps {
  profiles: FamilyProfile[];
  avatarUrls: Record<string, string>;
}

export function AvatarStack({ profiles, avatarUrls }: AvatarStackProps) {
  if (profiles.length === 0) return null;

  return (
    <ul className="avatar-list" aria-label="Persone presenti">
      {profiles.map((profile) => (
        <li key={profile.id} className="avatar-person">
          <span className="avatar-person__photo">
            {avatarUrls[profile.id] ? (
              <img src={avatarUrls[profile.id]} alt="" width="52" height="52" />
            ) : (
              <span aria-hidden="true">{profile.display_name.slice(0, 1).toUpperCase()}</span>
            )}
          </span>
          <span className="avatar-person__details">
            <strong>{profile.display_name}</strong>
            <small>{formatLastSeen(profile.last_seen_at)}</small>
            {profile.note_text && <small className="avatar-person__note">“{profile.note_text}”</small>}
          </span>
        </li>
      ))}
    </ul>
  );
}
